import { TMobileModes } from '@shared/types/frontend/tables';
import { useLocalStorage } from 'usehooks-ts';
export default function useAppDetails() {
  const [isNativeApp, setIsNativeApp] = useLocalStorage('isNativeApp', false);
  const [isAppleNativeApp, setIsAppleNativeApp] = useLocalStorage('isAppleNativeApp', false);
  const [isGoogleNativeApp, setIsGoogleNativeApp] = useLocalStorage('isGoogleNativeApp', false);
  const [referralUrlCode, setReferralUrlCode] = useLocalStorage('referral-code', '');
  const [blockApp, setBlockApp] = useLocalStorage('blockApp', false);
  const [blockAppVersion, setBlockAppVersion] = useLocalStorage('blockAppVersion', false);
  const [mobileMode, setMobileMode] = useLocalStorage<TMobileModes>('mobileMode', 'home');
  return {
    isNativeApp,
    setIsNativeApp,
    isAppleNativeApp,
    setIsAppleNativeApp,
    isGoogleNativeApp,
    setIsGoogleNativeApp,
    referralUrlCode,
    setReferralUrlCode,
    blockApp,
    setBlockApp,
    blockAppVersion,
    setBlockAppVersion,
    mobileMode,
    setMobileMode
  };
}